import { shopifyFetch } from './client'
import { aspectRatio, orientation } from './imageShape'
import { PRODUCTS_QUERY, PRODUCT_BY_HANDLE_QUERY, COLLECTION_QUERY } from './queries'

function mapProduct(p) {
  const variant = p.variants.nodes[0]
  return {
    id: p.id,
    handle: p.handle,
    variantId: variant?.id,
    title: p.title,
    description: p.description,
    descriptionHtml: p.descriptionHtml,
    image: p.featuredImage?.url || null,
    imageAlt: p.featuredImage?.altText || p.title,
    // Only the single-product query asks for the full image list.
    images: (p.images?.nodes || []).map((img) => ({
      url: img.url,
      alt: img.altText || p.title,
      width: img.width,
      height: img.height,
      ratio: aspectRatio(img),
      orientation: orientation(img),
    })),
    price: p.priceRange.minVariantPrice.amount,
    currency: p.priceRange.minVariantPrice.currencyCode,
    availableForSale: variant?.availableForSale ?? p.availableForSale,
  }
}

export async function fetchProducts(first = 10, query = null) {
  const data = await shopifyFetch(PRODUCTS_QUERY, { first, query })
  return data.products.nodes.map(mapProduct)
}

export async function fetchProductByHandle(handle) {
  const data = await shopifyFetch(PRODUCT_BY_HANDLE_QUERY, { handle })
  return data.product ? mapProduct(data.product) : null
}

// Resolves to null when no collection with that handle exists in Shopify.
export async function fetchCollection(handle, first = 24) {
  const data = await shopifyFetch(COLLECTION_QUERY, { handle, first })
  if (!data.collection) return null
  return {
    title: data.collection.title,
    description: data.collection.description,
    products: data.collection.products.nodes.map(mapProduct),
  }
}
